var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.705,
    height: 31.705,
    viewBox: "0 0 31.705 31.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165599",
    "data-name": "Grupo 165599",
    transform: "translate(-286.056 -57.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164806",
    "data-name": "Grupo 164806",
    transform: "translate(287.055 58.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97565",
    "data-name": "Trazado 97565",
    d: "M6.3,17.853H3L17.853,3,32.705,17.853H29.4",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#004990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97566",
    "data-name": "Trazado 97566",
    d: "M5,12V23.552a3.3,3.3,0,0,0,3.3,3.3H24.8a3.3,3.3,0,0,0,3.3-3.3V12",
    transform: "translate(-1.699 2.853)",
    fill: "none",
    stroke: "#004990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97567",
    "data-name": "Trazado 97567",
    d: "M9,26.2V16.3A3.3,3.3,0,0,1,12.3,13h3.3a3.3,3.3,0,0,1,3.3,3.3v9.9",
    transform: "translate(0.902 3.503)",
    fill: "none",
    stroke: "#004990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.04b1b6fa93ca69f2e3342ca8e8a7ffc1.svg";
export { ForwardRef as ReactComponent };